import type { DealPromptFilters } from './types.ts';

const IGNORED_FILTERS: (keyof DealPromptFilters)[] = ['goal'];

export const criteriaHasSelectedFilters = (filters: DealPromptFilters = {}) => {
  return Object.entries(filters).some(([key, val]) => {
    if (IGNORED_FILTERS.includes(key as keyof DealPromptFilters)) return false;

    if (Array.isArray(val)) return val.length > 0;

    if (val && typeof val === 'object') return Object.keys(val).length > 0;

    return Boolean(val);
  });
};
